<template>
  <!-- <div class="c-logo" v-show="showLogo">
    <img src="@/assets/img/medgate_logo.svg" alt="Medgate Logo" />
  </div>
  <p>
    <b
      >Bitte lesen und bestätigen Sie, dass Sie mit den Datenschutzbestimmungen
      einverstanden sind.</b
    >
  </p> -->
  <ion-list lines="none">
    <ion-item>
      <ion-checkbox slot="start" v-model="privacy1"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich möchte die Fernbehandlung von Medgate nutzen und
        <u
          ><a href="#" @click.prevent="openInfoModal(privacy1Text)"
            >stimme der Verarbeitung meiner personenbezogenen Daten
          </a></u
        >
        hierfür durch Medgate zu.
      </ion-label>
    </ion-item>
    <!-- <ion-item>
      <ion-checkbox slot="start" v-model="privacy2"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich suche einen Arzt und möchte ein Arztgespräch per Video oder Telefon
        buchen und stimme der
        <u
          ><a href="#" @click.prevent="openInfoModal(privacy2Text)"
            >Verarbeitung meiner Daten
          </a></u
        >
        durch Medgate zu.
      </ion-label>
    </ion-item> -->
  </ion-list>
  <!-- <ion-row v-if="showNextButton">
    <ion-col>
      <next-question-button
        :disabled="!privacy1 || !privacy2"
        @click="$emit('done')"
      />
    </ion-col>
  </ion-row> -->
</template>

<script>
import {
  IonList,
  IonItem,
  IonCheckbox,
  IonLabel,
  modalController,
  // IonRow,
  // IonCol,
  // IonButton,
} from "@ionic/vue";
// import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import InfoModal from "@lib/components/InfoModal";

export default {
  emits: ["done", "checked", "unchecked"],
  components: {
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel,
    // NextQuestionButton,
    // IonRow,
    // IonCol,
    // IonButton,
  },
  props: {
    showLogo: {
      required: false,
      type: Boolean,
      default: true,
    },
    showNextButton: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      privacy1: false,
      privacy2: false,
      privacy1Text:
        "<p>Ihre angegebenen Daten (Anrede, Vorname, Nachname, PLZ, E-Mail-Adresse, Telefonnummer) werden im Zuge der Vertragserfüllung an Medgate, weitergeleitet und von Medgate für die Registrierung gespeichert und verarbeitet. Die Rechtsgrundlage iSd Datenschutz-Grundverordnung (DSGVO) ist hierbei Art 6 Abs 1 lit b DSGVO.</p>",
      privacy2Text:
        "<p>Die Angaben zu Ihren Symptomen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer, Information zur ARAG-Krankenversicherung und die Vertragsdaten (E-Mail-Adresse, Passwort, Vorname, Nachname und Adresse) werden an Medgate weitergegeben und von diesen gespeichert und verarbeitet, um die individuelle Suche bearbeiten zu können und um medizinische Spezialisten vermitteln zu können. Damit Ihre Suchanfrage beantwortet werden kann, benötigt Medgate von Ihnen ebenso Angaben zu Ihrer physischen und möglicherweise auch psychischen Verfassung. Hierbei handelt es sich um Gesundheitsdaten im Sinne der Datenschutz-Grundverordnung Art.4 Nr.15 DSGVO.</p><p>Medgate stellt Ihre angegebenen Daten in Folge dem gewählten Medgate-Arzt bereit, der beschließt, ob ein Gespräch per Video/Telefon oder in dessen Praxis zu buchen ist. Ferner werden die Daten des behandelnden Arztes (Vorname, Nachname, Fachrichtung), Zeitpunkt und Form (via Telefon oder Video) des Termins verarbeitet und an Roodie weitergegeben. Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder geistige Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>",
    };
  },
  watch: {
    privacy1() {
      this.checkPrivacy();
    },
    privacy2() {
      this.checkPrivacy();
    },
  },
  methods: {
    checkPrivacy() {
      if (
        this.privacy1
        // && this.privacy2
      ) {
        this.$emit("checked");
      } else {
        this.$emit("unchecked");
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped>
.c-logo {
  max-width: 200px;
  display: inline-block;
  margin-right: 20px;
}
</style>
